import React, { useEffect, useState } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import '../styles/pdfExport.css';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, Button
} from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL;

const MaquinasTable = () => {
  const [maquinas, setMaquinas] = useState([]);

  useEffect(() => {
    const fetchMaquinas = async () => {
      try {
        const res = await axios.get(`${API_URL}/maquinas`);
        setMaquinas(res.data);
      } catch (error) {
        console.error('Error al obtener las máquinas:', error);
      }
    };
    fetchMaquinas();
  }, []);

  // Función para descargar la tabla como PDF
  const descargarPDF = () => {
    const input = document.getElementById('tabla-maquinas');
    if (!input) return;
    input.classList.add('pdf-export');
    
    html2canvas(input, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff'
    }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'a4'
      });
      
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const marginX = 10;
      const marginY = 15;
      const imgWidth = pdfWidth - (marginX * 2);
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
      const pageContentHeight = pdfHeight - (marginY * 2);
      
      let heightLeft = imgHeight;
      let position = marginY;
      
      pdf.addImage(imgData, 'PNG', marginX, position, imgWidth, imgHeight);
      heightLeft -= pageContentHeight;
      
      while (heightLeft > 0) {
        position = -(imgHeight - heightLeft) + marginY;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', marginX, position, imgWidth, imgHeight);
        heightLeft -= pageContentHeight;
      }
      
      pdf.save('sensores-maquinas.pdf');
      input.classList.remove('pdf-export');
    });
  };

  return (
    <Box sx={{ mt: 4, maxWidth: 900, mx: 'auto' }}>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button variant="outlined" color="secondary" onClick={descargarPDF}>
          Descargar PDF
        </Button>
      </Box>
      <Box id="tabla-maquinas">
        <Typography variant="h5" align="center" sx={{ mb: 2, color: '#555', fontWeight: 'bold' }}>
          Sensores para cada máquina
        </Typography>
        <TableContainer component={Paper} sx={{ maxHeight: '600px' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: 'white', fontFamily: 'Roboto' }}>Nombre</TableCell>
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: 'white', fontFamily: 'Roboto' }}>Número de Máquina</TableCell>
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: 'white', fontFamily: 'Roboto' }}>Sensor</TableCell>
                <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#071525', color: 'white', fontFamily: 'Roboto' }}>Fecha de Registro</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {maquinas.map((m) => (
                <TableRow
                  key={m._id}
                  sx={{ '&:hover': { backgroundColor: '#424242' } }}
                >
                  <TableCell sx={{ fontFamily: 'Roboto' }}>{m.machine}</TableCell>
                  <TableCell sx={{ fontFamily: 'Roboto' }}>{m.machineNumber}</TableCell>
                  <TableCell sx={{ fontFamily: 'Roboto' }}>{m.sensorNumber}</TableCell>
                  <TableCell sx={{ fontFamily: 'Roboto' }}>
                    {m.createdAt ? new Date(m.createdAt).toLocaleDateString() : ''}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default MaquinasTable;